import { dev, building } from '$app/environment'

export const handleError = async ({ error }) => {
  if (dev || building) {
    console.error(error)
  }
};